import React, { useState, useRef, useEffect } from "react";
import { useLang } from "@/context/LanguageContext";
import { CaretDoubleLeft, CaretLeft, CaretRight, CaretDoubleRight, CaretDown } from "@phosphor-icons/react";

const OPTIONS = [10, 25, 50, 100, 200];

const NavBtn = ({ onClick, disabled, children, testid }) => (
  <button data-testid={testid} onClick={onClick} disabled={disabled}
    className="flex h-9 w-10 items-center justify-center border border-border bg-card text-primary transition-colors duration-150 hover:bg-muted disabled:cursor-not-allowed disabled:opacity-35">
    {children}
  </button>
);

export const Pagination = ({ page, perPage, total, onPage, onPerPage, testid = "pagination" }) => {
  const { t } = useLang();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  useEffect(() => {
    const h = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", h);
    return () => document.removeEventListener("mousedown", h);
  }, []);

  const totalPages = Math.max(1, Math.ceil((total || 0) / perPage));
  const start = total === 0 ? 0 : (page - 1) * perPage + 1;
  const end = Math.min(page * perPage, total || 0);

  return (
    <div className="flex items-center gap-1.5" data-testid={testid}>
      <NavBtn testid={`${testid}-first`} onClick={() => onPage(1)} disabled={page <= 1}><CaretDoubleLeft size={16} weight="bold" /></NavBtn>
      <NavBtn testid={`${testid}-prev`} onClick={() => onPage(page - 1)} disabled={page <= 1}><CaretLeft size={16} weight="bold" /></NavBtn>
      <div className="relative" ref={ref}>
        <button data-testid={`${testid}-label`} onClick={() => setOpen((o) => !o)}
          className="flex h-9 items-center gap-1.5 border border-border bg-card px-4 text-sm font-semibold text-primary transition-colors duration-150 hover:bg-muted">
          {start}–{end} {t.of} {total || 0}
          <CaretDown size={13} weight="bold" className={`transition-transform duration-150 ${open ? "rotate-180" : ""}`} />
        </button>
        {open && (
          <div data-testid={`${testid}-menu`} className="absolute left-0 top-11 z-30 w-44 border border-border bg-card shadow-lg">
            {OPTIONS.map((n) => (
              <button key={n} data-testid={`${testid}-opt-${n}`}
                onClick={() => { onPerPage(n); setOpen(false); }}
                className={`block w-full px-4 py-2.5 text-left text-sm transition-colors duration-100 hover:bg-primary hover:text-white ${n === perPage ? "font-bold text-primary" : "text-foreground"}`}>
                {n} {t.perPage}
              </button>
            ))}
          </div>
        )}
      </div>
      <NavBtn testid={`${testid}-next`} onClick={() => onPage(page + 1)} disabled={page >= totalPages}><CaretRight size={16} weight="bold" /></NavBtn>
      <NavBtn testid={`${testid}-last`} onClick={() => onPage(totalPages)} disabled={page >= totalPages}><CaretDoubleRight size={16} weight="bold" /></NavBtn>
    </div>
  );
};
